import { useMemo } from 'react';
import { getChartSunlightTimes } from 'selectors/graphs';
import { useAppSelector } from 'stores/hooks';
import { SunlightTimes } from 'types/sunlightTimes';
import { oneDay, oneHour } from 'utils/time';

const useNonPremiumRewindTime = (now: number, skip: boolean) => {
  const sunlightTimes: SunlightTimes = useAppSelector(getChartSunlightTimes);

  const time = useMemo(() => {
    if (skip) return undefined;
    const sunriseSeconds = sunlightTimes?.days?.[0]?.sunrise;
    const sunrise = sunriseSeconds ? sunriseSeconds * 1000 : undefined;

    const sunsetSeconds = sunlightTimes?.days?.[0]?.sunset;
    const sunset = sunsetSeconds ? sunsetSeconds * 1000 - oneHour : undefined;

    if (!sunrise || !sunset) return undefined;
    if (now < sunrise) {
      return sunset - oneDay * 2;
    }

    if (now > sunset) {
      return sunset - oneDay;
    }

    return now - oneDay;
  }, [now, sunlightTimes, skip]);

  const nonPremiumRewindTime = useMemo(
    () => ({
      time,
      loading: !!sunlightTimes?.loading,
    }),
    [time, sunlightTimes?.loading],
  );

  return nonPremiumRewindTime;
};

export default useNonPremiumRewindTime;
